<template>
  <div id="data-view">
    <dv-full-screen-container>
      <div class="main-header">

        <dv-decoration-8 class="header-left-decoration" />

        <dv-decoration-5 :dur="4" class="header-center-decoration" />
        <dv-decoration-8 class="header-right-decoration" :reverse="true" />
        <div class="center-title" ref="spanTitle" v-on:click="speakTtsSpeech111">高昌区第四幼儿园</div>
        <div class="classlabel">{{classInfo}}</div>
        <div class="timelabel">{{currDate}}</div>
        <!-- <audio ref="audioId" :src="mp3Url" controls ></audio> -->

      </div>

      <dv-border-box-7 class="main-container">

        <dv-border-box-7 class="left-main-container">
          <Left-Chart-1 :list="list1"/>
        </dv-border-box-7>

        <div class="center-main-container">

          <div class="a111">
            <div class="rmctc-right-container">
              <dv-border-box-7 class="rmctc-chart-1">
                <Right-Chart-1 :info="info" :allCount="info.allCount" :allWait="info.allWait"/>
              </dv-border-box-7>

              <dv-border-box-7 class="rmctc-chart-2">
                <Right-Chart-2 :allActive="info.allActive"/>
              </dv-border-box-7>
            </div>
          </div>

          <dv-border-box-7 class="a222">
            <Bottom-Charts :list="paixu"/>
          </dv-border-box-7>
        </div>

        <dv-border-box-7 class="right-main-container">
          <Left-Chart-2 :list="list2"/>
        </dv-border-box-7>
      </dv-border-box-7>
    </dv-full-screen-container>
  </div>
</template>

<script>

import LeftChart1 from './LeftChart1'
import LeftChart2 from './LeftChart2'
import RightChart1 from './RightChart1'
import RightChart2 from './RightChart2'
import BottomCharts from './BottomCharts'

export default {
  name: 'DataView',
  components: {
    LeftChart1,
    LeftChart2,
    RightChart1,
    RightChart2,
    BottomCharts
  },
  data () {
    return {
      speech: null,
      class_id: '',
      currDate: '',
      classInfo: '',
      timer: '',
      timerData: '',
      timerVoice: '',
      info: {},
      list1: [],
      list2: [],
      paixu: [],
      mp3Url: null,
      is_play: false
    }
  },
  created () {
    this.getUrlParam()
    this.onTestHandler()
    this.timer = setInterval(this.getDate, 1000)
    this.timerData = setInterval(this.refreshAllData, 4000)
    this.timerVoice = setInterval(this.refreshVoiceData, 10000)
    // this.classInfo = '小班1班 老师：XXXX 班级总人数 30人'
  },
  mounted () {
    console.info('已挂在tts')
    // this.speechInit()
    // // setTimeout(() => {
    // //   this.speakTtsSpeech111()
    // // }, 2000)
    // setTimeout(() => {
    //   this.$refs.spanTitle.click()
    //   console.log('自动触发点击')
    // }, 2000)
    this.refreshAllXuesheng()
  },
  watch: {
    // mp3Url: function (val) {
    //   setTimeout(() => { // 设置延迟执行
    //     this.$refs.audio.load()
    //     this.$refs.audio.play()
    //   }, 2000)
    // }
  },
  methods: {
    // 播放音频
    aclick (src) {
      // this.$refs.audio.src = src
      // if (this.is_play) {
      //   this.$refs['audio'].pause()
      //   this.is_play = false
      // } else {
      //   this.$refs['audio'].play()
      //   this.is_play = true
      // }
    },
    speechInit () {
      // this.speech = new Speech()
      // this.speech.setLanguage('zh-CN')
      // this.speech.init().then(() => {})
      // this.speakTtsSpeech111()
    },
    speakTtsSpeech (msg) {
      // let msg = '你好，我叫风过无痕.'
      this.speech.speak({ text: msg }).then(() => {
        console.log('播报成功')
      })
    },
    speakTtsSpeech111 () {
      console.info('2222')
      // if (this.speech.hasBrowserSupport()) {

      // }
      let msg = '语音播报已启用'
      this.speech.speak({ text: msg }).then(() => {
        console.log('播报成功')
      })
    },
    getUrlParam () {
      let url = window.location.href // 获取当前url
      let dzUrl = url.split('#')[0] // 获取#/之前的字符串
      let cs = dzUrl.split('?')[1] // 获取?之后的参数字符串
      let csArr = cs.split('&') // 参数字符串分割为数组
      let p = {}
      for (let i = 0; i < csArr.length; i++) {
        // 遍历数组，拿到json对象
        p[csArr[i].split('=')[0]] = csArr[i].split('=')[1]
      }
      this.class_id = p.class_id
      // 插入本地变量
      localStorage.setItem('class_id', this.class_id)
    },
    getDate () {
      let date = new Date()
      var time
      let year = date.getFullYear() // 年
      let month = date.getMonth() + 1 // 月
      let day = date.getDate() // 日
      let week = date.getDay() // 星期
      let weekArr = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      ]
      let hour = date.getHours() // 时
      hour = hour < 10 ? '0' + hour : hour // 如果只有一位，则前面补零
      let minute = date.getMinutes() // 分
      minute = minute < 10 ? '0' + minute : minute // 补零
      let second = date.getSeconds() // 秒
      second = second < 10 ? '0' + second : second // 补零
      time = `${year}/${month}/${day} ${hour}:${minute}:${second} ${weekArr[week]}`
      // console.log(time) // 2022/12/30 15:12:14 星期五
      this.currDate = time
      return time
    },
    refreshAllXuesheng () {
      this.$http({
        url: 'https://jh.hscxny.com/aaa/app_api_jiesong/getAllXuesheng?classid=' + this.class_id
      }).then((res) => {
        this.list1 = res.data.data.beibis
      }, (err) => {
        console.log('err', err)
      })
    },
    refreshVoiceData () {
      // 语音播报
      this.$http({
        url: 'https://jh.hscxny.com/aaa/app_api_jiesong/getVoice?classid=' + this.class_id
      }).then((res) => {
        console.info(res.data.data)
        this.info = res.data.data
        if (res.data.data.voice) {
          // this.mp3Url = res.data.data.voice_url
          // this.$refs.audioId.play()
          // let audio = new Audio(this.mp3Url)
          // audio.play()
        }
      }, (err) => {
        console.log('err', err)
      })
    },

    refreshAllData () {
      this.$http({
        url: 'https://jh.hscxny.com/aaa/app_api_jiesong/getclassInfo?classid=' + this.class_id
      }).then((res) => {
        console.info(res.data.data)
        this.info = res.data.data
        // this.list1 = res.data.data.beibis
        this.list2 = res.data.data.records
        this.paixu = res.data.data.paixu
        this.classInfo = this.info.dept_name + ' 老师：' + this.info.teacherInfo + ' 班级总人数 ' + this.info.all_beibi + '人'
      }, (err) => {
        console.log('err', err)
      })
    },
    onTestHandler () {
      console.log('getdata')
      this.$http({
        url: 'https://jh.hscxny.com/aaa/app_api_jiesong/getclassInfo?classid=' + this.class_id
      }).then((res) => {
        debugger
        this.info = res.data.data
        // this.list1 = res.data.data.beibis
        this.list2 = res.data.data.records
        this.paixu = res.data.data.paixu
        this.classInfo = this.info.dept_name + ' 老师：' + this.info.teacherInfo + ' 班级总人数 ' + this.info.all_beibi + '人'
      }, (err) => {
        console.log('err', err)
      })
    }

  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.timerData)
    clearInterval(this.timerVoice)
  }

}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url("./img/bg.png");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .timelabel{
font-size: 20px;
position:absolute;
right: 80px;
    top: 20px;

  }
  .classlabel{
    font-size: 20px;
position:absolute;
left: 60px;
    top: 20px;
  }

  .main-header {
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .header-center-decoration {
      width: 40%;
      height: 60px;
      margin-top: 30px;
    }

    .header-left-decoration,
    .header-right-decoration {
      width: 25%;
      height: 60px;
    }

    .center-title {
      position: absolute;
      font-size: 30px;
      font-weight: bold;
      left: 50%;
      top: 15px;
      transform: translateX(-50%);
    }
  }

  .main-container {
    height: calc(~"100% - 100px");

    .border-box-content {
      padding: 10px;
      box-sizing: border-box;
      display: flex;
    }
  }

  .left-main-container {
    width: 22%;
    padding: 10px;
    box-sizing: border-box;

    .border-box-content {
      flex-direction: column;
    }
  }

  .right-main-container {
    width: 30%;
    padding: 10px;
    box-sizing: border-box;

    .border-box-content {
      flex-direction: column;
    }
  }

  .center-main-container {
    width: 55%;
    padding-left: 5px;
    box-sizing: border-box;
  }

  .a111 {
    width: 100%;
    height: calc(~"65%");
  }

  .rmctc-left-container {
    width: 65%;
  }

  .rmctc-right-container {
    display: flex;
    justify-content: center;
    height: 100%;
  }

  .a222 {
    height: 35%;
  }

  .rmctc-chart-1,
  .rmctc-chart-2 {
    height: 100%;
    width: 100%;
  }
}
</style>
